SftpServersListController.$inject = ['$scope', '$mdDialog', 'company', 'TopToolbarFactory',  'ConfirmationFactory', 'SftpServersFactory', 'AlertingFactory'];
export function SftpServersListController($scope, $mdDialog, company, TopToolbarFactory, ConfirmationFactory, SftpServersFactory, AlertingFactory) {

  $scope.editSftpServer = editSftpServer;
  $scope.deleteSftpServer = deleteSftpServer;

  init();

  function loadSftpServersList() {
    SftpServersFactory.getSftpServersList(company.id).then(
      result => {
        $scope.sftpServers = result.data;
      },
      error => AlertingFactory.error('bug/unexpected-error')
    )
  }

  function openEditionDialog(isCreation, sftpServer) {
    if (!sftpServer) {
      sftpServer = {}
    }

    $mdDialog.show({
      controller: 'SftpServerEditionController',
      template: require('./sftp-server-edition.html'),
      clickOutsideToClose: false,
      resolve: {},
      locals: {
        company: company,
        sftpServer: angular.copy(sftpServer),
        isCreation: isCreation
      }
    })
    .then(function(modifiedSftpServer) {
      if (isCreation) {
        SftpServersFactory.createSftpServer(company.id, modifiedSftpServer)
        .then(function(response) {
          AlertingFactory.success('sftp-servers/edition/creation-success');
          loadSftpServersList();
        }, AlertingFactory.httpErrorHandler());
      }
      else {
        SftpServersFactory.updateSftpServer(company.id, modifiedSftpServer)
        .then(function(response) {
          AlertingFactory.success('sftp-servers/edition/edit-success');
          loadSftpServersList();
        }, AlertingFactory.httpErrorHandler());
      }
    });
  }

  function createSftpServer() {
    openEditionDialog(true);
  }

  function editSftpServer(sftpServer, event) {
    openEditionDialog(false, sftpServer);
  }

  function deleteSftpServer(sftpServer) {
    ConfirmationFactory.materialConfirmDialog('sftp-servers/list/confirm-deletion')
      .then(function() {
        SftpServersFactory.deleteSftpServer(company.id, sftpServer)
          .then(function(response) {
            AlertingFactory.success('sftp-servers/list/delete-success');
            let sftpServerIndex = $scope.sftpServers.indexOf(sftpServer);
            $scope.sftpServers.splice(sftpServerIndex, 1);
          }, AlertingFactory.httpErrorHandler());
    });
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('sftp-servers/list/title', $scope);
    TopToolbarFactory.setButton('sftp-servers/list/create', createSftpServer, $scope);

    $scope.selected = [];
    $scope.sortColumn = 'created_time';
    loadSftpServersList();
  }

}
